import { __assign, __extends, __makeTemplateObject, __read, __spread } from "tslib";
import React, { Component } from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';
import * as animations from 'react-animations';
import { css, keyframes } from 'styled-components';
import Portal from '../Portal';
import { Flex } from '../Flex';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { createComponent } from '../utils';
import { emitter } from './toast';
import { Types, Events, Positions, PositionConfigs } from './config';
var VariantToColorMap = {
    success: 'green',
    error: 'red',
    warn: 'orange',
    info: 'blue',
};
var getTransitionStyle = function (state, position, duration) {
    var _a = PositionConfigs[position], animationIn = _a.animationIn, animationOut = _a.animationOut;
    switch (state) {
        case 'entering':
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        animation: ", "ms ", ";\n      "], ["\n        animation: ", "ms ", ";\n      "])), duration, keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), animations[animationIn]));
        case 'exiting':
            return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        animation: ", "ms ", ";\n      "], ["\n        animation: ", "ms ", ";\n      "])), duration, keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), animations[animationOut]));
        default:
            return css(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
    }
};
var ToastPortal = createComponent({
    name: 'ToastPortal',
    style: function (_a) {
        var position = _a.position;
        return PositionConfigs[position].wrapperStyle;
    },
});
var Toast = createComponent({
    name: 'Toast',
    style: function (_a) {
        var state = _a.state, type = _a.type, position = _a.position, animationDuration = _a.animationDuration, theme = _a.theme;
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: 0.75rem 1rem;\n    min-width: 250px;\n    max-width: 400px;\n    cursor: pointer;\n    color: white;\n    font-weight: 600;\n    border-radius: ", "px;\n    box-shadow: ", ";\n    background: ", ";\n    transition: 175ms;\n    z-index: 5000;\n\n    ", ";\n\n    & + & {\n      margin-top: 0.5rem;\n    }\n\n    &:hover {\n      box-shadow: ", ";\n    }\n  "], ["\n    padding: 0.75rem 1rem;\n    min-width: 250px;\n    max-width: 400px;\n    cursor: pointer;\n    color: white;\n    font-weight: 600;\n    border-radius: ", "px;\n    box-shadow: ", ";\n    background: ", ";\n    transition: 175ms;\n    z-index: 5000;\n\n    ", ";\n\n    & + & {\n      margin-top: 0.5rem;\n    }\n\n    &:hover {\n      box-shadow: ", ";\n    }\n  "])), theme.radius, theme.shadow.soft, theme.colors[VariantToColorMap[type]], getTransitionStyle(state, position, animationDuration), theme.shadow.hard);
    },
});
var ToastContainer = (function (_super) {
    __extends(ToastContainer, _super);
    function ToastContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.counter = 0;
        _this.state = {
            toasts: [],
        };
        _this.add = function (options) {
            if (options === void 0) { options = {}; }
            var id = ++_this.counter;
            var toast = __assign(__assign(__assign({}, _this.props), options), { id: id });
            _this.setState(function (state) { return (__assign(__assign({}, state), { toasts: __spread(state.toasts, [toast]) })); }, function () {
                if (toast.autoClose) {
                    setTimeout(function () {
                        _this.remove(id);
                    }, (toast.timeout || 0) + (toast.animationDuration || 0));
                }
            });
        };
        _this.remove = function (id) {
            _this.setState(function (state) { return ({
                toasts: state.toasts.filter(function (t) { return t.id !== id; }),
            }); });
        };
        _this.handleToastClick = function (toast) {
            if (toast.closeOnClick) {
                _this.remove(toast.id);
            }
        };
        return _this;
    }
    ToastContainer.prototype.componentDidMount = function () {
        emitter.on(Events.ADD, this.add);
    };
    ToastContainer.prototype.componentWillUnmount = function () {
        emitter.off(Events.ADD, this.add);
    };
    ToastContainer.prototype.render = function () {
        var _this = this;
        var toasts = this.state.toasts;
        return Object.keys(Positions).map(function (key) {
            var p = Positions[key];
            return (React.createElement(Portal, { key: p },
                React.createElement(ToastPortal, { position: p },
                    React.createElement(TransitionGroup, null, toasts
                        .filter(function (t) { return t.position === p; })
                        .map(function (toast) { return (React.createElement(Transition, { key: toast.id, timeout: toast.animationDuration, appear: true, unmountOnExit: true }, function (state) { return (React.createElement(Toast, __assign({}, toast, { state: state, onClick: function () { return _this.handleToastClick(toast); } }),
                        React.createElement(Flex, { alignItems: "flex-start" },
                            React.createElement(Box, { flex: 1 }, toast.message),
                            toast.showClose && React.createElement(Icon, { name: "close", onClick: function () { return _this.remove(toast.id); } })))); })); })))));
        });
    };
    ToastContainer.defaultProps = {
        type: Types.INFO,
        position: Positions.TOP_CENTER,
        timeout: 5000,
        animationDuration: 250,
        autoClose: true,
        closeOnClick: true,
        showClose: true,
    };
    return ToastContainer;
}(Component));
export default ToastContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=ToastContainer.js.map